<template>
    <div class="card-facilities-resources">
        <CardHeaderComponent :level="this.currentLevel" :name="this.name" :description="this.description" />
        <CardResourcesComponent :resources="productionData" title="Actual Production"/>
        <hr />
        <CardResourcesComponent :resources="productionNextLevelData" title="Next Level Improvements" />
        <hr />
        <div class="card-requirements-container">
            <CardRequirementsComponent :resources="nextLevelResourceRequeriments" :requeriments="this.requirementCollection" />
        </div>
        <div class="card-time-container">
            <ProgressBarComponent 
                :totalTime="nextLevelTimeToBuild" 
                :elapsedTime="currentElapsedTime" 
                :showProgressBar="isBuilding"
                :callbackEvent="finishBuildEvent" 
                />
        </div>
        <div v-if="!canBeBuilt && !isBuilding" class="card-alert-container">
            <AlertComponent :variant="alertVariantConstant.ERROR_ALERT">You do not meet the requirements to build</AlertComponent>
        </div>
        <div v-if="!isBuilding" class="card-button-container">
            <ButtonComponent 
                :text="getButtonText" 
                :type="buttonConstant.PRIMARY_TYPE_BUTTON" 
                :onClickEvent="build" 
                :disabled="!canBeBuilt" />
        </div>
        <!-- <div class="card-bg-container">
            <svg width="auto" height="auto" viewBox="0 0 353 352" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.8">
                    <path
                        d="M176.5 176C176.5 152.887 171.935 130.001 163.065 108.648C154.195 87.2944 141.194 67.8923 124.804 51.5492C108.415 35.2061 88.9576 22.242 67.5436 13.3972C46.1296 4.55237 23.1783 0 0 0V105.6C9.27131 105.6 18.4518 107.421 27.0174 110.959C35.583 114.497 43.3659 119.682 49.9217 126.22C56.4775 132.757 61.6779 140.518 65.2259 149.059C68.7739 157.6 70.6 166.755 70.6 176H176.5Z"
                        fill="#F5F5F5" />
                    <path
                        d="M176.5 352C176.5 328.887 171.935 306.001 163.065 284.648C154.195 263.294 141.194 243.892 124.804 227.549C108.415 211.206 88.9576 198.242 67.5436 189.397C46.1296 180.552 23.1783 176 0 176V281.6C9.27131 281.6 18.4518 283.421 27.0174 286.959C35.583 290.497 43.3659 295.682 49.9217 302.22C56.4775 308.757 61.6779 316.518 65.2259 325.059C68.7739 333.6 70.6 342.755 70.6 352H176.5Z"
                        fill="#F5F5F5" />
                    <path
                        d="M353 176C353 152.887 348.435 130.001 339.565 108.648C330.695 87.2944 317.694 67.8923 301.304 51.5492C284.915 35.2061 265.458 22.242 244.044 13.3972C222.63 4.55237 199.678 0 176.5 0V105.6C185.771 105.6 194.952 107.421 203.517 110.959C212.083 114.497 219.866 119.682 226.422 126.22C232.978 132.757 238.178 140.518 241.726 149.059C245.274 157.6 247.1 166.755 247.1 176V352H353L353 176Z"
                        fill="#F5F5F5" />
                </g>
            </svg>
        </div> -->
    </div>
</template>

<style scoped>
.card-facilities-resources {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: var(--border-radius-s);
    border: 1px solid var(--border-1);
    background: var(--background-1);
    overflow: hidden;
}

.card-surface-timer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: var(--border-radius-xs);
    border: 1px solid var(--border-1);
    background-color: var(--background-2);
    overflow: hidden;
}

.card-requirements-container {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    max-height: 300px;
}

.card-surface-title {
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background-color: var(--background-1);
}

.card-surface-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
}

.card-time-container {
    display: flex;
    padding: 0px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.card-alert-container {
    display: flex;
    padding: 0px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.card-button-container {
    display: flex;
    flex-grow: 1;
    height: 100%;
    padding: 16px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.card-bg-container {
    display: flex;
    flex-grow: 1;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}
</style>

<script>
import * as alertVariantConstant from '@/constants/alertVariantConstant';
import * as buttonConstant from '@/constants/buttonConstant';
import * as resourceConstant from '@/constants/resourceConstant';
import * as resourceStyleConstant from '@/constants/resourceStyleClassConstant';

import { hoverEffect } from '@/composables/hoverEffectComposable';

import { userPlanetDataStorage } from '@/storages/userPlanetDataStorage';
import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import AlertComponent from './core/AlertComponent.vue';
import ButtonComponent from './core/button/ButtonComponent.vue';
import CardHeaderComponent from './card/CardHeaderComponent.vue';
import CardRequirementsComponent from './card/CardRequirementsComponent.vue';
import CardResourcesComponent from './card/CardResourcesComponent.vue';
import ProgressBarComponent from './core/ProgressBarComponent.vue';

export default {
    name: 'BuildingCardComponent',
    components: {
        AlertComponent,
        ButtonComponent,
        CardHeaderComponent,
        CardRequirementsComponent,
        CardResourcesComponent,
        ProgressBarComponent
    },
    setup() {
        hoverEffect();

        const userPlanetDataStorageInstance = userPlanetDataStorage();
        const userLoginDataStorageInstance = userLoginDataStorage();

        return {
            alertVariantConstant, 
            buttonConstant,
            resourceConstant,
            resourceStyleConstant,
            userPlanetDataStorageInstance,
            userLoginDataStorageInstance
        };
    },
    props: {
        buildingTypeId: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        currentLevel: {
            type: [Number, null],
            default: null
        },
        isBuilt: {
            type: Boolean,
            required: true
        },
        planetQueue: {
            type: [Object, null],
            default: null
        },
        requirementCollection: {
            type: Array,
            default: () => []
        },
        levelCollection: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId()
        }
    },
    computed: {
        nextLevel() {
            return this.isBuilt ? this.currentLevel + 1: 0;
        },
        syncPlanetQueue: {
            get() {
                return this.planetQueue
            },
            set(newValue) {
                this.$emit('update:planetQueue', newValue);
            }
        },
        isBuilding() {
            return null !== this.syncPlanetQueue;
        },
        productionData() {
            if (false === this.isBuilt) {
                return [];
            }

            const productionData = this.levelCollection[0];
            const metal = this.getMetal(productionData);
            const crystal = this.getCrystal(productionData);
            const deuterium = this.getDeuterium(productionData);
            const energy = this.getEnergy(productionData);

            let resources = [];
            if (0 !== metal) {
                resources.push(
                    {type: resourceConstant.METAL_RESOURCE, amount: metal, status: this.getResourceStatus(metal)}
                );
            }
            if (0 !== crystal) {
                resources.push(
                    {type: resourceConstant.CRYSTAL_RESOURCE, amount: crystal, status: this.getResourceStatus(crystal)}
                );
            }
            if (0 !== deuterium) {
                resources.push(
                    {type: resourceConstant.DEUTERIUM_RESOURCE, amount: deuterium, status: this.getResourceStatus(deuterium)}
                );
            }
            if (0 !== energy) {
                resources.push(
                    {type: resourceConstant.ENERGY_RESOURCE, amount: energy, status: this.getResourceStatus(energy)}
                );
            }

            return resources;
        },
        productionNextLevelData() {
            const position = this.isBuilt ? 1 : 0;
            const nextProductionData = this.levelCollection[position];
            const productionData =  this.isBuilt ? this.levelCollection[0] : {};

            const metal = this.getMetal(nextProductionData) - this.getMetal(productionData);
            const crystal = this.getCrystal(nextProductionData) - this.getCrystal(productionData);
            const deuterium = this.getDeuterium(nextProductionData) - this.getDeuterium(productionData);
            const energy = this.getEnergy(nextProductionData) - this.getEnergy(productionData);

            let resources = [];
            if (0 !== metal) {
                resources.push(
                    {type: resourceConstant.METAL_RESOURCE, amount: metal, status: this.getResourceStatus(metal, true)}
                );
            }
            if (0 !== crystal) {
                resources.push(
                    {type: resourceConstant.CRYSTAL_RESOURCE, amount: crystal, status: this.getResourceStatus(crystal, true)}
                );
            }
            if (0 !== deuterium) {
                resources.push(
                    {type: resourceConstant.DEUTERIUM_RESOURCE, amount: deuterium, status: this.getResourceStatus(deuterium, true)}
                );
            }
            if (0 !== energy) {
                resources.push(
                    {type: resourceConstant.ENERGY_RESOURCE, amount: energy, status: this.getResourceStatus(energy, true)}
                );
            }

            return resources;
        },
        nextLevelResourceRequeriments() {
            const position = this.isBuilt ? 1 : 0;
            const requerimentsData = this.levelCollection[position];

            const metal = this.getMetal(requerimentsData, true);
            const crystal = this.getCrystal(requerimentsData, true);
            const deuterium = this.getDeuterium(requerimentsData, true);

            const userPlanetData = this.userPlanetDataStorageInstance.getPlanetById(this.planetId);

            return [
                {type: resourceConstant.METAL_RESOURCE, amount: metal, status: this.getResourceStatus(metal, false, userPlanetData.metal)},
                {type: resourceConstant.CRYSTAL_RESOURCE, amount: crystal, status: this.getResourceStatus(crystal, false, userPlanetData.crystal)},
                {type: resourceConstant.DEUTERIUM_RESOURCE, amount: deuterium, status: this.getResourceStatus(deuterium, false, userPlanetData.deuterium)}
            ];
        },
        nextLevelTimeToBuild() {
            if (undefined === this.syncPlanetQueue?.finishAt) {
                const position = this.isBuilt ? 1 : 0;
                const requerimentsData = this.levelCollection[position];

                return requerimentsData?.secondsToBuild;
            }

            const createdAt = new Date(this.syncPlanetQueue?.createdAt);
            const finishAt = new Date(this.syncPlanetQueue?.finishAt);
            
            return Math.round((finishAt - createdAt) / 1000);
        },
        canBeBuilt() {
            let canBeBuilt = true;

            for (const resource of this.nextLevelResourceRequeriments) {
                if (resourceStyleConstant.NEGATIVE_RESOURCE_STYLE === resource.status) {
                    canBeBuilt = false;
                    break;
                }
            }

            if (canBeBuilt) {
                for (const requeriment of this.requirementCollection) {
                    if (false === requeriment.accomplish) {
                        canBeBuilt = false;
                        break;
                    }
                }
            }

            return canBeBuilt;
        },
        currentElapsedTime() {
            if (undefined === this.syncPlanetQueue?.finishAt) {
                return 0;
            }

            const createdAt = new Date(this.syncPlanetQueue?.createdAt);
            const now = new Date();
            
            return Math.round((now - createdAt) / 1000);
        },
        getButtonText() {
            return this.isBuilt ? `Upgrade to level ${this.nextLevel}`: 'Build'
        }
    },
    methods: {
        getMetal(levelCollection, getPrice = false) {
            if (getPrice) {
                return levelCollection?.metalPrice ?? 0
            }
            return (levelCollection?.metalProduction ?? 0) + (levelCollection?.metalCost ?? 0);
        },
        getCrystal(levelCollection, getPrice = false) {
            if (getPrice) {
                return levelCollection?.crystalPrice ?? 0
            }
            return (levelCollection?.crystalProduction ?? 0) + (levelCollection?.crystalCost ?? 0);
        },
        getDeuterium(levelCollection, getPrice = false) {
            if (getPrice) {
                return levelCollection?.deuteriumPrice ?? 0
            }
            return (levelCollection?.deuteriumProduction ?? 0) + (levelCollection?.deuteriumCost ?? 0);
        },
        getEnergy(levelCollection) {
            return (levelCollection?.energyProduction ?? 0) + (levelCollection?.energyCost ?? 0);
        },
        getResourceStatus(amount, plusMode = false, minusCompareAmount) {
            if (0 > amount || undefined !== minusCompareAmount && minusCompareAmount < amount) {
                return resourceStyleConstant.NEGATIVE_RESOURCE_STYLE;
            }
            if (plusMode) {
                return resourceStyleConstant.PLUS_RESOURCE_STYLE;
            }
            
            return resourceStyleConstant.DEFAULT_RESOURCE_STYLE;
        },
        async build() {
            try {
                const response = await this.$axios.buildBuilding(this.planetId, this.buildingTypeId);
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.syncPlanetQueue = response.data;

                await this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            } catch(error) {
                console.error("Error building: ", error);
            }
        },
        finishBuildEvent() {
            this.syncPlanetQueue = null;
        }
    }
}
</script>